'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

exports["default"] = function (_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['theme']);

  var component = _react2["default"].createElement(ActionButtonRow, props);

  return theme ? _react2["default"].createElement(_util.ThemeProvider, {
    theme: theme
  }, component) : component;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _constants = require('../constants');

var _ActionButton = require('./ActionButton');

var _ActionButton2 = _interopRequireDefault(_ActionButton);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    _root: {},
    root: {
      pointerEvents: 'none',
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'center',
      minHeight: theme.buttonSize,
      width: '100%',
      '& > *': {
        borderWidth: [[4, 2, 0, 2], '!important'],
        borderStyle: ['solid', '!important'],
        borderColor: [theme.colorButton, '!important']
      }
    },
    disabled: {
      cursor: 'not-allowed'
    }
  };
};

var ActionButtonRow = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(ActionButtonRow, _React$Component);

  function ActionButtonRow() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ActionButtonRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ActionButtonRow.__proto__ || Object.getPrototypeOf(ActionButtonRow)).call.apply(_ref2, [this].concat(args))), _this), _this.getTitle = function (id) {
      var text = _this.props.translate ? _this.props.translate(id) : id;

      if (!_this.props.keymap) {
        return text;
      }

      var keys = _this.props.keymap[id];
      var shortcut = keys.join(', ');
      return text + ' (' + shortcut + ')';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActionButtonRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          buttons = _props.buttons,
          handlers = _props.handlers,
          disabled = _props.disabled,
          ButtonBase = _props.ButtonBase,
          classes = _props.classes;
      var rowClassNames = (0, _classnames2["default"])('prodigy-buttons', classes.root, classes._root, _defineProperty({}, classes.disabled, disabled));
      return _react2["default"].createElement('div', {
        className: rowClassNames
      }, buttons.map(function (id) {
        return _react2["default"].createElement(_ActionButton2["default"], {
          type: id,
          key: id,
          onClick: handlers && handlers[id],
          disabled: disabled,
          title: _this2.getTitle(id),
          ButtonBase: ButtonBase
        });
      }));
    }
  }]);

  return ActionButtonRow;
}(_react2["default"].Component), _class2.defaultProps = {
  buttons: _constants.BUTTONS
}, _class2.propTypes = {
  handlers: _propTypes2["default"].object,
  keymap: _propTypes2["default"].object,
  buttons: _propTypes2["default"].array,
  disabled: _propTypes2["default"].bool,
  translate: _propTypes2["default"].func
}, _temp2)) || _class);